module.exports = __webpack_public_path__ + "img/thumb_14.64930dac.jpg";